import React from 'react';
import ScheduleSummaryDisplay from './ScheduleSummaryDisplay';
import { formatDateTime, isScheduledMessageOverdue } from '../utils';

function ScheduledMessageAgendaCell({ item }) {
  const overdue = isScheduledMessageOverdue(item);
  const nextRunAt = formatDateTime(item.next_run_at);

  return (
    <div className="min-w-0 space-y-0.5">
      <p
        className="font-medium text-content-primary truncate"
        title={item.template_name || undefined}
      >
        {item.template_name || '—'}
      </p>
      <p className="text-xs text-content-muted truncate" title={item.cron || item.scheduled_at || undefined}>
        <ScheduleSummaryDisplay item={item} compact />
      </p>
      <div className="flex items-center gap-1.5 text-xs text-content-muted">
        {overdue && (
          <span
            className="inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-[10px] font-medium bg-red-50 text-red-700 border border-red-200"
            title="Horário de envio já passou"
          >
            Atrasado
          </span>
        )}
        <span className="truncate" title={nextRunAt}>
          Próx.: {nextRunAt}
        </span>
      </div>
    </div>
  );
}

export default ScheduledMessageAgendaCell;
